import { Box, css, Text, useTheme } from "@chakra-ui/react"
import Link from "next/link"

import { useRouter } from "next/router"

import Colors from "@constants/colors"
import { bp } from "@utils/MediaQueries"
import { formatDateToLocaleString } from "@utils/dates"
import { formatArticleTypeNames } from "@components/Article"

export interface ISnippetProps {
  title: string
  publishDate: string
  articleTypes: any
  snippet: string
  slug: string
}

const Snippet: React.FC<ISnippetProps> = ({
  publishDate,
  snippet,
  title,
  articleTypes,
  slug,
}) => {
  const router = useRouter()
  const theme = useTheme()
  const styles = css({
    fontFamily: "Avenir",
    header: {
      fontSize: bp("19px", null, "27.5px"),
      fontWeight: "800",
      marginBottom: bp(".5rem", null, "1rem"),
    },
    span: {
      color: Colors.midAccessible,
      fontWeight: "500",
    },
    p: {
      color: Colors.midAccessible,
      paddingY: bp("1.5rem", null, "2rem"),
    },
    "a:hover": {
      borderBottom: `1px solid ${Colors.brand}`,
    },
    a: {
      color: Colors.brand,
    },
  })(theme)

  return (
    <Box css={styles}>
      <Link href={`${router.asPath}/${slug}`}>
        <Text cursor="pointer" as="header">
          {title}
        </Text>
      </Link>
      <Text as="span">
        {formatDateToLocaleString(publishDate)} -{" "}
        {formatArticleTypeNames(articleTypes, router.asPath)}
      </Text>
      <Text>{snippet}</Text>
      <Link href={`${router.asPath}/${slug}`}>
        <a>→ Read More</a>
      </Link>
    </Box>
  )
}

export default Snippet
